<template>
	<div ref="chart"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
	props: ["options"],
	name: "chart-el",
	data(){
		return {
			chartDom: {},
		}
	},
	watch: {
		options(val){
			this.chartDom.setOption(val)
		},
	},
	destoryed(){
		window.removeEventListener('resize', this.resizeCharts)
	},
	mounted(){
		window.addEventListener('resize', this.resizeCharts);
		// 初始化
		this.chartDom = echarts.init(this.$refs.chart);
		if(this.options){
			this.chartDom.setOption(this.options);
		}
	},
	methods: {
		resizeCharts(){
			this.chartDom.resize();
		},
	}
}
</script>